export default __webpack_public_path__ + "static/media/login-logo.9aac89f6.png";